// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import {
    Card, CardContent, CardActions, TextField, makeStyles, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase, Switch,
    Dialog, DialogContent, DialogTitle, InputAdornment, DialogActions
} from '@material-ui/core';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

const discountTypes = [
    {
        value: 'FINAL_PRICE',
        label: 'قیمت نهایی',
    },

];


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const sendToServerCampaignPrices = async (data) => {
    if (data.campaignId) {
        const Update_CAMPAIGN = gql`
        mutation UpdateCampaignPrice($where: CampaignPriceWhereUniqueInput!, $data: CampaignPriceUpdateInput!){
            updateCampaignPrice(where: $where, data: $data){
                id
            }
        }
      `;

        const { campaignId, ...newData } = data;

        await client.mutate({
            mutation: Update_CAMPAIGN,
            variables: {
                where: { id: campaignId },
                data: newData
            }
        }).then((res) => {
            // if (!res.data.errors) {
            //     setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
            //     return res.data;
            // }
            // else {
            //     console.log('error: ', res.data)
            //     if (res.data.errors[0].message.includes("Unique constraint failed on the fields: (`code`)"))
            //         setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
            //     else
            //         setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })

            // }
        }).catch(e => {
            console.log('error catch: ', e)
            // if (JSON.stringify(e).includes("Unique constraint failed on the fields: (`code`)"))
            //     setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
            // else
            //     setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        })
    }

    else {
        const CREATE_CAMPAIGN = gql`
        mutation CreateCompaignPrice($data: CampaignPriceCreateInput!){
            createCampaignPrice(data: $data){
                id
            }
        }
      `;

        await client.mutate({
            mutation: CREATE_CAMPAIGN,
            variables: {
                data: data
            }
        }).then((res) => {
            console.log('submit: ', res.data)
            // if (!res.data.errors) {
            //     setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
            //     return res.data;
            // }
            // else {
            //     console.log('error: ', res.data)
            //     if (res.data.errors[0].message.includes("Unique constraint failed on the fields: (`code`)"))
            //         setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
            //     else
            //         setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })

            // }
        }).catch(e => {
            console.log('error catch: ', e)
            // if (JSON.stringify(e).includes("Unique constraint failed on the fields: (`code`)"))
            //     setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
            // else
            //     setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        })
    }

}

const getQueryParams = () => {
    let search = window.location.hash.split('?')[1]
    const params = new URLSearchParams(search)
    return params.getAll("id")[0]
}

const productType: any = {
    MENTOR: "حامی",
    DIET: "رژیم",
    BUNDLE: "باندل",
    PSYCHOLOGY_SESSION: "روان‌شناسی"
}

export function CampaignEdit() {
    const classes = useStyles();
    const [discountType, setDiscountType] = React.useState('FINAL_PRICE');
    const [modal, setModal] = React.useState<Boolean>(false);
    const [currentBundle, setCurrentBundle] = React.useState(null);
    const [productDiscount, setProductDiscount] = React.useState<Array<any>>([]);
    const [originalProductDiscount, setOriginalProductDiscount] = React.useState<Array<any>>([]);
    const [rowsLoading, setRowsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        id: null,
        utmCampaign: null,
        startDate: null,
        endDate: null,
        campaignName: null,
        loading: true,
        tags: []
    });
    const [status, setStatus] = React.useState({ loading: false, message: '', hasError: false });

    const prepareDataToSendServer = (selectedProducts: Array<any>, data: any): any => {
        let result = []
        selectedProducts.forEach((sp: any) => {
            let originalPD = originalProductDiscount.find(opd => opd.id === sp.id)
            if (originalPD.enable !== sp.enable || originalPD.price !== sp.price || originalPD.offValue !== sp.offValue) {
                let sendData = {
                    ...data,
                    productId: sp.id,
                    price: Number(sp.price),
                    offValue: Number(sp.offValue),
                    isEnabled: sp.enable,
                    meta: sp.meta,
                    campaignId: sp.campaignId
                }
                if (originalPD.productType !== "BUNDLE")
                    delete sendData.meta;

                result.push(sendData);
            }
            else if (sp.enable) {
                let sendData = {
                    ...data,
                    productId: sp.id,
                    price: Number(sp.price),
                    offValue: Number(sp.offValue),
                    isEnabled: sp.enable,
                    meta: sp.meta,
                    campaignId: sp.campaignId
                }
                if (originalPD.productType !== "BUNDLE")
                    delete sendData.meta;
                result.push(sendData);
            }
        })
        if (result.length === 0) {
            selectedProducts.forEach((sp: any) => {
                if (sp.enable)
                    result.push({ ...data, productId: sp.id, price: Number(sp.price), offValue: Number(sp.offValue), isEnabled: sp.enable, meta: sp.meta, campaignId: sp.campaignId });
            })
        }
        return result;
    }

    const sendBulkToServer = (sendToServerData: Array<any>) => {
        let promises: any[] = []
        sendToServerData.forEach((d: any) => {
            promises.push(sendToServerCampaignPrices(d))
        })
        Promise.all(promises)
            .then(res => {
                console.log('promise All Finished');
                setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
                window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/CampaignPrice`
            })
            .catch(e => { console.log('promise All catch: ', e); setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true }) })
    }

    async function getCampaigns(campaignId) {
        const GET_Campaigns = gql`
        query GetCampaignPrices($where: CampaignPriceWhereInput){
            campaignPrices(where: $where){
              createdAt
              createdBy
              description
              startDate
              endDate
              offValue
              id
              productId
              price
              utmCampaign
              isEnabled
              type
              name
              meta
              tags
            }
          }
      `;
        return await client.query({
            query: GET_Campaigns,
            variables: {
                where: {
                    utmCampaign: { equals: campaignId }
                }
            }
        }).then((res) => {
            let campaignResult = res.data.campaignPrices;
            setDiscountType(campaignResult[0].type)
            setValues({
                utmCampaign: campaignResult[0].utmCampaign,
                startDate: campaignResult[0]?.startDate?.substring(0, 10),
                endDate: campaignResult[0]?.endDate?.substring(0, 10),
                campaignName: campaignResult[0].name,
                loading: false,
                id: campaignId,
                tags: campaignResult[0]?.tags?.map((tag) => { return { key: tag.toUpperCase(), label: tag } })
            })
            return campaignResult;
        }).catch((err)=>{
            setStatus({ loading: false, message: ' کد کمپین یافت نشد', hasError: true })
            setValues({ ...values,loading:false })
            setRowsLoading(true)   
        })
    }

    async function getAllProducts(campaigns) {
        const GET_Products = gql`
        query Products($where: ProductWhereInput) {
            products(where: $where) {
              id
              title
              productType
              meta       
            }
        }
      `;
        let result: Array<any> = await client.query({
            query: GET_Products,
            variables: {
                where: {
                    service: { equals: process.env.REACT_APP_SERVICE },
                    isEnabled: { equals: true }
                },
            }
        }).then((res) => {
            return res.data.products;
        })

        let pd = []
        result.forEach((product: any) => {
            let isAvailable = false;
            campaigns.forEach(c => {
                if (c.productId === product.id) {
                    isAvailable = true;
                    let price = c?.meta?.products ? c.meta.products.reduce((prev, obj) => { return prev += (obj.price - obj.offValue) }, 0) : c.price;
                    let offValue = c?.meta?.products ? c.meta.products.reduce((prev, obj) => { return prev += (obj.offValue) }, 0) : c.offValue;
                    pd.push({ ...product, price: price, offValue: offValue, enable: c.isEnabled, meta: c.meta, campaignId: c.id })
                }
            });
            if (!isAvailable)
                pd.push({ ...product, price: '', offValue: '', enable: false })
        })
        console.log('pd: ', pd)
        setProductDiscount(pd)
        setOriginalProductDiscount(pd)
        setRowsLoading(true)
    }

    const handleDiscountType = (event: any) => {
        console.log('handleDiscountType');
        setDiscountType(event.target.value);
    };

    const handlerEnabled = (productId: any) => { 
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId){
                console.log("BEFORE: ", { id: pd.id, enable: pd.enable } )
                console.log("AFTER: ", { id: pd.id, enable: !pd.enable } )
                return { ...pd, enable: !pd.enable }; 
            }
                
            return pd;
        })
        if (currentBundle)
            setCurrentBundle({ ...currentBundle, enable: !currentBundle.enable })
        setProductDiscount(result)
    }

    const handlerEditBundle = (productId: any) => {
        setCurrentBundle(null)
        let bundle = productDiscount.filter(pd => pd.productType === "BUNDLE").find(pd => pd.id === productId);
        console.log('current bundle: ', bundle);
        setCurrentBundle(bundle)
        if (bundle)
            setModal(true)
    }

    const campaignNameHandler = (value: any) => {
        console.log('campaignNameHandler');
        setValues({ ...values, campaignName: value })
    }

    const utmCampaignHandler = (value: any) => {
        console.log('utmCampaignHandler');
        setValues({ ...values, utmCampaign: value })
    }

    const startDateHandler = (value: any) => {
        setValues({ ...values, startDate: value })
    }

    const endDateHandler = (value: any) => {
        console.log('endDateHandler');
        setValues({ ...values, endDate: value })
    }

    const handlerFinalPrice = (value: any, productId: any) => {
        console.log('handlerFinalPrice');
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, price: value };
            return pd;
        })
        setProductDiscount(result)
    }

    const handlerOffValue = (value: any, productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, offValue: value };
            return pd;
        })
        setProductDiscount(result)
    }

    const handleDeleteTag = (chipToDelete) => () => {
        setValues({ ...values, tags: values.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = values?.tags?.some(t => t.key === newTagLabel.toUpperCase())
        let newTags = [...values?.tags ?? [], { key: newTagLabel.toUpperCase(), label: newTagLabel }]
        if (!existTag && newTagLabel !== "")
            setValues({ ...values, tags: newTags })
    }

    const handlerOffValueBundle = (value: any, productId: any) => {
        let productDiscountCopy = currentBundle.meta.products.map(pd => Object.assign({}, pd))
        let bundleProducts = productDiscountCopy.map(p => {
            if (p.id === productId)
                p.offValue = Number(value)
            return p;
        })

        setCurrentBundle({ ...currentBundle, meta: { products: bundleProducts } })
    }

    const handlerPriceBundle = (value: any, productId: any) => {

        let productDiscountCopy = currentBundle.meta.products.map(pd => Object.assign({}, pd))

        let bundleProducts = productDiscountCopy.map(p => {
            if (p.id === productId)
                p.price = Number(value)
            return p;
        })

        setCurrentBundle({ ...currentBundle, meta: { products: bundleProducts } })
    }

    const submitBundle = () => {
        console.log('currentBundle: ', currentBundle);
        let result = productDiscount.map((pd: any) => {
            if (pd.id === currentBundle.id) {
                let price = pd.enable ? currentBundle.meta.products.reduce((prev, obj) => { return prev += (obj.price - obj.offValue) }, 0) : ''
                let offValue = pd.enable ? currentBundle.meta.products.reduce((prev, obj) => { return prev += obj.offValue }, 0) : ''
                return { ...pd, price: price, offValue: offValue, enable: pd.enable, meta: { products: currentBundle.meta.products } };
            }
            return pd;
        })
        console.log('submitBundle: ', result)
        setProductDiscount(result)
        setModal(false)
    }

    const submitDiscount = async () => {
        setStatus({ message: '', loading: true, hasError: false })
        let data = {
            name: values.campaignName,
            type: discountType,
            startDate: values.startDate,
            endDate: values.endDate,
            utmCampaign: values.utmCampaign,
            tags: values.tags.map(tag => tag.label),
            ...(productDiscount.length !== 0 && { price: Number(productDiscount[0]?.price) }),
            ...(productDiscount.length !== 0 && { offValue: Number(productDiscount[0]?.offValue) }),
        }
        let sendToServerData: Array<any> = prepareDataToSendServer(productDiscount, data)
        sendBulkToServer(sendToServerData)
    }

    React.useEffect(() => {
        let campaignId = getQueryParams()
        getCampaigns(campaignId)
            .then((res: any) => {
                getAllProducts(res);
            })

    }, [])

    return (
        <Card>
            <CardContent>


                <Dialog
                    onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
                    disableEscapeKeyDown
                    maxWidth="xs"
                    aria-labelledby="confirmation-dialog-title"
                    open={modal}
                >

                    <DialogTitle id="confirmation-dialog-title">لیست محصولات {currentBundle?.title}</DialogTitle>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <Switch
                            checked={currentBundle?.enable} 
                            onClick={(e: any) => handlerEnabled(currentBundle?.id)}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </div>


                    <DialogContent>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {currentBundle?.meta?.products?.map((p: any) =>
                            (
                                <div style={{ border: '1px solid #41424C', padding: '8px', marginBottom: '8px', borderRadius: '8px' }} key={p?.id}>
                                    <p className="text-IranSans-Bold" style={{ textAlign: 'right', direction: 'rtl', marginTop: '0px' }}>{p?.title}</p>
                                    <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <p className="text-IranSans-Light" style={{ marginLeft: '10px' }}>قیمت اصلی</p>
                                        <TextField
                                            onChange={(e: any) => handlerPriceBundle(e.target.value, p.id)}
                                            disabled={!currentBundle?.enable}
                                            variant="outlined"
                                            value={currentBundle?.meta.products.find(product => product.id === p.id).price}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">تومان</InputAdornment>,
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <p className="text-IranSans-Light" style={{ marginLeft: '10px' }}>مبلغ تخفیف</p>
                                        <TextField
                                            onChange={(e: any) => handlerOffValueBundle(e.target.value, p.id)}
                                            disabled={!currentBundle?.enable}
                                            variant="outlined"
                                            value={currentBundle?.meta.products.find(product => product.id === p.id).offValue}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">تومان</InputAdornment>,
                                            }}
                                        />
                                    </div>
                                </div>

                            )
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={(e) => setModal(false)} color="primary">
                            لغو
                        </Button>
                        <Button onClick={(e) => submitBundle()} color="primary">
                            تایید
                        </Button>
                    </DialogActions>
                </Dialog>

                {
                    !values.loading ?
                        <div style={{ display: "flex", flexDirection: 'column', marginBottom: '1rem' }}>
                            <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField
                                    fullWidth
                                    label="نوع تخفیف"
                                    size="medium"
                                    disabled
                                    id="outlined-select-currency-native"
                                    select
                                    onChange={(e: any) => handleDiscountType()}
                                    variant="outlined"
                                    value={discountType}
                                >
                                    {discountTypes.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </TextField>

                                <TextField fullWidth onChange={(e: any) => campaignNameHandler(e.target.value)} value={values.campaignName} size="medium" label="نام کمپین" variant="outlined"></TextField>

                                <TextField fullWidth onChange={(e: any) => utmCampaignHandler(e.target.value)} value={values.utmCampaign} label="کد کمپین" size="medium" variant="outlined"></TextField>


                            </div>
                            <div style={{ display: "flex", flexDirection: 'row', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField
                                    fullWidth
                                    onChange={(e: any) => startDateHandler(e.target.value)}
                                    label="تاریخ شروع"
                                    value={values.startDate}
                                    size="medium"
                                    id="todate"
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                                <TextField
                                    fullWidth
                                    onChange={(e: any) => endDateHandler(e.target.value)}
                                    label="تاریخ پایان"
                                    value={values.endDate}
                                    size="medium"
                                    id="todate"
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                {/* <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                    <Switch
                                        checked={values.isEnabled}
                                        onChange={(e: any) => setValues({ ...values, isEnabled: !values.isEnabled })}
                                        color="primary"
                                        name="checkedA"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </div> */}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center' }}>
                                <div className={classes.root}>
                                    {values.tags?.map((data) => {
                                        return (
                                            <li key={data.key}>
                                                <Chip
                                                    label={data.label}
                                                    onDelete={handleDeleteTag(data)}
                                                    className={classes.chip}
                                                    variant="outlined"
                                                />
                                            </li>
                                        );
                                    })}

                                </div>
                                <TextField fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></TextField>
                            </div>
                        </div> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                {
                    rowsLoading ?
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 700 }} align="center">محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">شناسه</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">نوع محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">فعال/غیرفعال</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ نهایی</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ تخفیف</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productDiscount.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell align="center">{productType[row.productType]}</TableCell>
                                            <TableCell align="center">
                                                {
                                                    row.productType !== "BUNDLE" ?
                                                        <Switch
                                                            checked={row.enable}
                                                            onChange={(e: any) => handlerEnabled(row.id)}
                                                            color="primary"
                                                            name="checkedA"
                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                        /> : <Button onClick={(e) => handlerEditBundle(row.id)} color="primary">ویرایش</Button>
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.price}
                                                    onChange={(e: any) => handlerFinalPrice(e.target.value, row.id)}
                                                    disabled={row.productType !== "BUNDLE" ? !row.enable : true}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ نهایی را وارد کنید"
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.offValue}
                                                    onChange={(e: any) => handlerOffValue(e.target.value, row.id)}
                                                    // disabled={row.productType !== "BUNDLE" ? !row.enable : true}
                                                    disabled={true}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ تخفیف را وارد کنید"
                                                />
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submitDiscount()} variant="contained" color="primary">ثبت</Button>
                    {
                        !status.loading && status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !status.loading && !status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }

                </div>
            </CardContent>
            <CardActions>

            </CardActions>
        </Card >
    )
}